import React from "react";
import Button from "./UI/Button/Button";

const Subscribe = () => {
	return (
		<section className="page__subscribe subscribe">
			<h2 className="subscribe__title">Subscribe us</h2>
			<h3 className="subscribe__subtitle">
				We promise to send you only the most important
				<br />
				and interesting :)
			</h3>

			<form
				action="#"
				method="post"
				encType="multipart/form-data"
				className="subscribe__form"
			>
				<input
					type="text"
					name="email"
					placeholder="Email"
					className="subscribe__form-input"
				/>
				<Button
					onClick={(e: any) => e.preventDefault()}
					className="subscribe__form-btn"
				>
					Send
				</Button>
			</form>

			<div className="subscribe__check-wrapper">
				<div className="subscribe__check-inner">
					<input
						type="checkbox"
						name="checkbox"
						id="sub__check"
						className="subscribe__check visuallyhidden"
					/>
					<label
						htmlFor="sub__check"
						className="subscribe__check-label"
					></label>
				</div>

				<p className="subscribe__check-text">
					By submitting data I agree with &nbsp;
					<a href="#" className="subscribe__check-link">
						Competition conditions
					</a>
					<br />и &nbsp;
					<a href="#" className="subscribe__check-link">
						Data Processing Policy
					</a>
				</p>
			</div>
		</section>
	);
};

export default Subscribe;
